import SuperRepository from '../superRepository'

export default new (class OfferPartnerBaselinePeriodHistoryRepository extends SuperRepository {
  baseUri() {
    return 'offer_partner_bl_period_history'
  }
})()